<template>
    <v-container fluid>
        <bank-account-form
            :model="bankAccount"
            @saved="saved"
            :titlePrefix="$t('bank-account.edit.texts.title-prefix')"
            v-if="bankAccount"
            :reseller_id="reseller_id"
        ></bank-account-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import BankAccountModel from '@/models/BankAccount'
import BankAccountForm from './Form'

export default {
    props: {
        id: {
            required: true,
        },
        reseller_id: {
            required: true,
        },
    },

    data: () => {
        return {
            bankAccount: null,
        }
    },

    components: {
        BankAccountForm,
    },

    methods: {
        async getBankAccount() {
            let bankAccount = await this.model.find(this.id)

            this.bankAccount = bankAccount
        },

        saved() {
            this.$router.push({ name: this.$t('bank-account.routes.index') })
        },
    },

    computed: {
        model() {
            return new BankAccountModel()
        },
    },

    created() {
        this.getBankAccount()
    },
}
</script>
